import { updateThreadPinned } from '@/services/chat/updateThreadPinned'

function nextPinnedIds(prev, threadId, pinned) {
  if (!pinned) return prev.filter((id) => id !== threadId)
  return [threadId, ...prev.filter((id) => id !== threadId)]
}

function withThreadPin(thread, pinned) {
  return {
    ...thread,
    pinned,
    pinnedAt: pinned ? new Date().toISOString() : null,
  }
}

export function applyThreadPinState(thread, m, pinned) {
  m.setPinnedThreadIds((prev) => nextPinnedIds(prev, thread.id, pinned))
  m.setThreads?.((prev) =>
    prev.map((item) => (item.id === thread.id ? withThreadPin(item, pinned) : item)),
  )
  void updateThreadPinned(thread.id, pinned).catch(() => {})
}
